export const EQUIPMENT_MODEL_PERMISSIONS = {
  LIST: 'equipment-model-list',
  CREATE: 'equipment-model-create',
  VIEW: 'equipment-model-view',
  EDIT: 'equipment-model-edit',
  DELETE: 'equipment-model-delete',
  BULK_DELETE: 'equipment-model-bulk-delete',
  PERMANENT_DELETE: 'equipment-model-permanent-delete',
  RESTORE: 'equipment-model-restore',
};

export const EQUIPMENT_MODEL_LIST_ACCESS = [
  EQUIPMENT_MODEL_PERMISSIONS.LIST,
  EQUIPMENT_MODEL_PERMISSIONS.CREATE,
  EQUIPMENT_MODEL_PERMISSIONS.VIEW,
  EQUIPMENT_MODEL_PERMISSIONS.EDIT,
  EQUIPMENT_MODEL_PERMISSIONS.DELETE,
  EQUIPMENT_MODEL_PERMISSIONS.BULK_DELETE,
  EQUIPMENT_MODEL_PERMISSIONS.PERMANENT_DELETE,
  EQUIPMENT_MODEL_PERMISSIONS.RESTORE,
];

export const EQUIPMENT_MODEL_VIEW_ACCESS = [
  EQUIPMENT_MODEL_PERMISSIONS.VIEW,
  EQUIPMENT_MODEL_PERMISSIONS.LIST,
  EQUIPMENT_MODEL_PERMISSIONS.EDIT,
];
